"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericTypeSchemaSchema = void 0;
exports.GenericTypeSchemaSchema = {
    "$id": "https://www.redbull.com/schemas/types/generic.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "GenericTypeSchema",
    "description": "Meta schema for generic type definition",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "id": {
            "type": "string",
            "pattern": "^(attributes|rrn:content|rrn:types|rrn:content:ext:services|rrn:abstract|rrn:patch|rrn:system:ext|rrn):([a-zA-Z0-9\\d\\-_]+)(:([\\d]+))?$"
        },
        "type": {
            "type": "string",
            "enum": [
                "rrn:types:generic"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "displayName": {
                    "type": "string",
                    "pattern": "^[A-Za-z0-9]+$"
                },
                "description": {
                    "type": "string"
                },
                "deprecated": {
                    "type": "string"
                },
                "examples": {
                    "type": "array",
                    "items": {
                        "type": "object"
                    }
                },
                "experimental": {
                    "type": "string"
                },
                "schema": {
                    "type": "object",
                    "properties": {
                        "properties": {
                            "description": "Those are the properties of the schema",
                            "type": "object",
                            "properties": {
                                "additionalProperties": true,
                                "type": {
                                    "type": "object",
                                    "properties": {
                                        "additionalProperties": false,
                                        "type": {
                                            "type": "string",
                                            "enum": [
                                                "string"
                                            ]
                                        }
                                    }
                                },
                                "attributes": {
                                    "type": "object",
                                    "properties": {
                                        "additionalProperties": true,
                                        "properties": {
                                            "patternProperties": {
                                                "^[a-zA-Z]+$": {
                                                    "type": "object",
                                                    "properties": {
                                                        "displayName": {
                                                            "type": "string",
                                                            "pattern": "^[A-Za-z0-9]+$"
                                                        }
                                                    },
                                                    "examples": [
                                                        {
                                                            "url": {
                                                                "type": "string",
                                                                "displayName": "VideoLink"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    "examples": [
                                        {
                                            "schema": null,
                                            "type": "object",
                                            "properties": {
                                                "type": {
                                                    "type": "string",
                                                    "enum": [
                                                        "example"
                                                    ]
                                                },
                                                "attributes": {
                                                    "type": "object",
                                                    "properties": {
                                                        "url": {
                                                            "type": "string",
                                                            "displayName": "Example",
                                                            "pattern": "examplePattern"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    ]
                                }
                            },
                            "required": [
                                "type"
                            ]
                        }
                    },
                    "required": [
                        "properties"
                    ]
                }
            },
            "required": [
                "schema",
                "displayName"
            ]
        },
        "relationships": {
            "type": "object",
            "properties": {
                "groups": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "id": {
                                        "type": "string",
                                        "pattern": "^rrn:type-groups:"
                                    },
                                    "type": {
                                        "type": "string",
                                        "enum": [
                                            "rrn:type-groups"
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    "required": [
        "attributes",
        "id",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,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